import { useEffect, useRef } from 'react';

const CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

/**
 * Renders Google's official "Continue with Google" button via Google Identity
 * Services (no npm dependency). Calls onCredential(idToken) on success.
 * Renders nothing until VITE_GOOGLE_CLIENT_ID is set.
 */
export default function GoogleButton({ onCredential }) {
  const ref = useRef(null);
  const cb = useRef(onCredential);
  cb.current = onCredential;

  useEffect(() => {
    if (!CLIENT_ID) return;
    let cancelled = false;

    const init = () => {
      if (cancelled || !window.google?.accounts?.id || !ref.current) return;
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: (resp) => cb.current?.(resp.credential),
      });
      ref.current.innerHTML = '';
      window.google.accounts.id.renderButton(ref.current, {
        theme: 'filled_black',
        size: 'large',
        shape: 'pill',
        text: 'continue_with',
        logo_alignment: 'center',
        width: 320,
      });
    };

    if (window.google?.accounts?.id) {
      init();
    } else {
      const id = 'gsi-client';
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.id = id;
        document.body.appendChild(script);
      }
      script.addEventListener('load', init);
    }
    return () => {
      cancelled = true;
    };
  }, []);

  if (!CLIENT_ID) return null;
  return <div ref={ref} className="flex justify-center" />;
}

export const googleConfigured = Boolean(CLIENT_ID);
